export default __webpack_public_path__ + "static/media/matrix-2.adbd43b3.png";